import { Redirect, Route, RouteProps } from "react-router-dom"

import { useAppSelector } from "@/App"
import { selectIsAuthenticated } from "@/store/user"

type PrivateRouteProps = { component: (props: unknown) => JSX.Element } & RouteProps

export const PrivateRoute = ({ component, ...props }: PrivateRouteProps) => {
  const isAuthenticated = useAppSelector(selectIsAuthenticated)

  // Prevent split-second flickering on initial load
  if (isAuthenticated === null) return null

  return <Route component={isAuthenticated ? component : () => <Redirect to="/zaloguj" />} {...props} />
}
